/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-login[_ngcontent-%COMP%] {\n  font-family: Raleway !important;\n  font-size: 9px !important;\n  font-weight: 600 !important;\n  font-stretch: normal !important;\n  font-style: normal !important;\n  line-height: normal !important;\n  letter-spacing: normal !important;\n  text-decoration: none !important; }\n\n@media (max-width: 600px) {\n  .landing-tabs[_ngcontent-%COMP%] {\n    padding-left: 1px;\n    padding-right: 1px; } }\n\n.fixed-content[_ngcontent-%COMP%] {\n  height: 400px;\n  width: 400px; }"];
export { styles as styles };
